import { ListGroup } from 'react-bootstrap';
import styled from 'styled-components';

const ListItem = styled(ListGroup.Item)`
  padding: 0;
  a {
    display: block;
    color: inherit;
    width: 100%;
    padding: 0.5rem 1.125rem;
    text-decoration: none;

    &:hover {
      background-color: ${({ theme }) => theme.colors.bgLight};
      border-left: 4px solid ${({ theme }) => theme.colors.primary};
    }

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;
type Props = {
  children: any;
};
const List = ({ children }: Props) => {
  return (
    <ListGroup>
      {children &&
        children.map((el: any, idx: number) => {
          if (!el) return null;
          return <ListItem key={`li-${el.key || idx}`}>{el}</ListItem>;
        })}
    </ListGroup>
  );
};

export default List;
